import React from 'react';
import { Link, Redirect } from 'react-router-dom';
class NotFoundPage extends React.Component {

	constructor(props) {
		super(props);
		console.log(props);
		console.log(props.location);
		this.state = {
			redirectToCreditCard: false
		};
	}

	componentDidMount() {
		if (this.props.location.pathname.includes("credit_card")) {
			this.setState({redirectToCreditCard: true})
			
		}
	}

	render() {
		console.log("NotFoundPage");
		console.log(window.location)
		if (this.state.redirectToCreditCard) {
			return <Redirect
				to={"/credit_card" + this.props.location.search} 
			/>;
		}
		else {
			return <div>
				<h1>Page Not Found</h1>
				<p>Sorry, there is nothing to see here.</p>
				<p><Link to="/">Back to Home</Link></p>
			</div>;
		}
	}
}
export { NotFoundPage };

